import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import "./SideBar.css";
import closeIcon from "../assets/icons/close.png";
import userIcon from "../assets/icons/man1.svg";

export default function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { user, loading, resetUserContext } = useContext(AppContext);

  const [visible, setVisible] = useState(false);

  // ---- animation control ----
  useEffect(() => {
    if (isOpen) {
      const t = setTimeout(() => setVisible(true), 10);
      return () => clearTimeout(t);
    } else {
      setVisible(false);
    }
  }, [isOpen]);

  // ---- MENU ITEMS ----
  const allItems = [
    { icon: "home", label: "Home", path: "/home" },
    { icon: "hammer", label: "My Bids", path: "/bids" },
    { icon: "doc", label: "Passbook", path: "/passbook" },
    { icon: "chat", label: "Chats", path: "/support" },
    { icon: "bank", label: "Funds", path: "/funds" },
    { icon: "bell", label: "Notifications", path: "/notifications" },
    { icon: "video", label: "Videos", path: "/videos" },
    { icon: "rules", label: "Notice Board / Rules", path: "/rules" },
    { icon: "rates", label: "Game Rates", path: "/rates" },
    { icon: "chart", label: "Charts", path: "/charts" },
    { icon: "idea", label: "Submit Idea", path: "/submit-idea" },
    { icon: "settings", label: "Settings", path: "/settings" },
    { icon: "share", label: "Share Application", path: "/share" },
    { icon: "logout", label: "Logout", action: "logout" },
  ];

  // ---- ACCOUNT FILTER ----
  const visibleItems =
    user?.accountStatus === true
      ? allItems
      : allItems.filter((i) => i.action === "logout");

  // ---- LOGOUT ----
  const handleLogout = () => {
    resetUserContext();
    navigate("/login-with-mpin", { replace: true });
    onClose?.();
  };

  // ---- ITEM CLICK ----
  const handleItemClick = (item) => {
    if (item.action === "logout") return handleLogout();

    if (item.path) {
      navigate(item.path);
      onClose?.();
      return;
    }

    if (item.href) {
      window.open(item.href, "_blank", "noopener,noreferrer");
      onClose?.();
    }
  };

  // ---- RENDER ----
  if (!isOpen) return null;

  return (
    <div className="sidebar-container">
      <div
        className={`sidebar-overlay ${visible ? "open" : ""}`}
        onClick={onClose}
      />

      <aside className={`sidebar ${visible ? "open" : ""}`}>
        {/* HEADER */}
        <header className="sidebar-header">
          <div className="user-info">
            <img
              src={user?.profilePicture || userIcon}
              alt="User"
              className="user-icon"
            />
            <div className="user-details">
              <div className="username">
                {loading ? "Loading..." : user?.fullName || "Guest"}
              </div>
              <div className="phone">
                {loading ? "" : user?.mobileNo || ""}
              </div>
            </div>
          </div>

          <button className="close-btn" onClick={onClose}>
            <img src={closeIcon} alt="Close" />
          </button>
        </header>

        {/* MENU */}
        <ul className="sidebar-menu">
          {visibleItems.map((item) => (
            <li key={item.label} onClick={() => handleItemClick(item)}>
              <span className={`sidebar-icon icon-${item.icon}`} />
              <span className="label">{item.label}</span>
            </li>
          ))}
        </ul>
      </aside>
    </div>
  );
}
